import type { CityConfig } from "../city-template/types";

export const bereaConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Berea",
  state: "Kentucky",
  stateAbbr: "KY",
  slug: "berea",
  route: "/berea",
  title: "Emergency Passport Berea, KY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Berea, KY — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Madison County and Appalachian travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Berea, KY",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Berea and Madison County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Berea%20Kentucky%20historic%20college%20town%20downtown%20at%20golden%20hour%20with%20charming%20arts%20and%20crafts%20district%2C%20Berea%20College%20campus%20buildings%20visible%2C%20warm%20Appalachian%20sunset%20light%20over%20rolling%20Madison%20County%20hills%2C%20artisan%20village%20atmosphere%2C%20clean%20modern%20cityscape%20photography%2C%20wide%20panoramic%20view%2C%20no%20visible%20text%20or%20people%2C%20vibrant%20Eastern%20Kentucky%20scene%20with%20green%20countryside%20and%20wooden%20artisan%20signs&width=1800&height=700&seq=berea-hero-001&orientation=landscape",
  heroImageAlt: "Berea Kentucky historic downtown at golden hour with Berea College campus and Appalachian hills",
  geoPosition: "37.5687;-84.2963",
  geoPlacename: "Berea, Kentucky",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "77 W Jackson Blvd, Suite 1200, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 350 miles from Berea via I-75",
  },
  nearbyCitiesZips: [
    { name: "Berea", zips: "40403, 40404" },
    { name: "Richmond", zips: "40475, 40476" },
    { name: "Mount Vernon", zips: "40456" },
    { name: "Irvine", zips: "40336" },
    { name: "Renfro Valley", zips: "40456" },
    { name: "McKee", zips: "40447" },
    { name: "London", zips: "40741, 40742, 40743, 40744, 40745, 40750" },
    { name: "Somerset", zips: "42501, 42502, 42503" },
    { name: "Nicholasville", zips: "40356" },
    { name: "Lexington", zips: "40502–40517, 40523–40526, 40533, 40536, 40544, 40546, 40550, 40555, 40574–40583, 40588, 40591, 40598" },
    { name: "Danville", zips: "40422, 40423" },
    { name: "Harrodsburg", zips: "40330" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Madison County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Louisville", route: "/louisville" },
    { name: "Fast passport renewal in Lexington", route: "/lexington" },
    { name: "Emergency passport help in Bowling Green", route: "/bowling-green" },
    { name: "Urgent passport services in Richmond", route: "/richmond" },
    { name: "Same-day passport help in Somerset", route: "/somerset" },
    { name: "Passport courier services near London", route: "/london" },
  ],
  fpcOfficeAddress: "500 W Jefferson St, Louisville, KY 40202",
  fpcOfficeNote: "Fast Passport Center serves Berea remotely via secure courier. We do not have a walk-in office in Berea — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Madison County travelers.",
  fpcOfficeDistance: "Serving all of Madison County and the Appalachian foothills",
  serviceAreaIntro: "From historic downtown Berea to the Berea College campus, from the Artisan Village to the surrounding Appalachian foothills — Fast Passport Center serves the entire Berea community and surrounding Madison County. We regularly help travelers from Richmond, Mount Vernon, and Irvine get their passports fast.",
  nearbyCitiesIntro: "We serve all Berea neighborhoods and nearby Appalachian foothills cities including Richmond, Mount Vernon, Irvine, Renfro Valley, McKee, London, Somerset, Nicholasville, Lexington, Danville, and Harrodsburg. If you are in Madison County, eastern Kentucky, or the Appalachian foothills, we have you covered.",
  howItWorksIntro: "Most Berea travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Berea travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Berea and Madison County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Berea? Here are the most common ones we hear from Madison County travelers.",
  statePageRoute: "/states/kentucky",
  statePageName: "Kentucky",
  dmvWebsite: "https://drive.ky.gov",
  dmvLabel: "Kentucky Transportation Cabinet — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Madison County international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Emily R.",
      location: "Berea, KY",
      rating: 5,
      text: "Study abroad in Spain was coming up and my passport was expired. Fast Passport Center got me a renewal in 4 days. I made my flight to Barcelona without any stress.",
      service: "Passport Renewal",
    },
    {
      name: "Daniel K.",
      location: "Richmond, KY",
      rating: 5,
      text: "My mother's health emergency required me to fly to London immediately. They got me an emergency passport in 24 hours. Compassionate and efficient service.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer M.",
      location: "Mount Vernon, KY",
      rating: 5,
      text: "First-time passport for my honeymoon cruise to the Caribbean. They helped me find the nearest acceptance facility and I had my passport in 5 days. Amazing support.",
      service: "New Passport",
    },
    {
      name: "Robert H.",
      location: "Irvine, KY",
      rating: 5,
      text: "Lost my passport before a business trip to Toronto. I was in a remote area and thought I was stuck. Their overnight shipping and 48-hour turnaround saved the trip.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "berea-1",
      name: "Berea Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "601 N Broadway",
      city: "Berea",
      state: "KY",
      zip: "40403",
      phone: "(859) 986-3121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Berea",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility for Madison County. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "berea-2",
      name: "Richmond Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "140 N Madison Ave",
      city: "Richmond",
      state: "KY",
      zip: "40475",
      phone: "(859) 623-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from downtown Richmond",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves eastern Madison County and neighboring areas. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "berea-3",
      name: "Mount Vernon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "150 E Main St",
      city: "Mount Vernon",
      state: "KY",
      zip: "40456",
      phone: "(606) 256-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Mount Vernon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Rockcastle County residents. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "berea-4",
      name: "London Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "204 S Main St",
      city: "London",
      state: "KY",
      zip: "40741",
      phone: "(606) 864-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from downtown London",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Laurel County and southern Madison County. Limited weekend hours.",
      icon: "ri-mail-line",
    },
    {
      id: "berea-5",
      name: "Somerset Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "405 W Mount Vernon St",
      city: "Somerset",
      state: "KY",
      zip: "42501",
      phone: "(606) 679-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.4 miles from downtown Somerset",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Pulaski County and southern Kentucky residents.",
      icon: "ri-mail-line",
    },
    {
      id: "berea-6",
      name: "Madison County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "135 W Irvine St",
      city: "Richmond",
      state: "KY",
      zip: "40475",
      phone: "(859) 624-4703",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.2 miles from Madison County Courthouse",
      website: "https://www.madisoncountyky.us/",
      websiteLabel: "Madison County Clerk",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5.5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Madison County photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Madison County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Berea applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Madison County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Madison County travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Berea." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Berea address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Berea before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Berea for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5.5 hour drive to Chicago." },
    { q: "How fast can I renew my passport in Berea?", a: "Fast Passport Center offers fast passport renewal in Berea in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. Many cruise lines require your passport to be valid for at least 6 months beyond your travel date. We can expedite your passport renewal in Berea in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Berea?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — a 5.5 hour drive from Berea — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Madison County residents." },
    { q: "Can I expedite a child passport in Berea?", a: "Yes. Fast Passport Center expedites child passports in Berea for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Madison County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Berea with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Berea?", a: "With Fast Passport Center's emergency courier service, Berea travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Berea?", a: "Popular options include the Berea Post Office (40403), Richmond Post Office (40475), Mount Vernon Post Office (40456), London Post Office (40741), Somerset Post Office (42501), and Madison County Clerk (40475). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Berea?", a: "Same-day passports are only available at the Chicago Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the 5.5 hour drive to Chicago." },
    { q: "What if I live in a smaller Madison County town?", a: "We serve the entire Madison County and surrounding area including Richmond, Mount Vernon, Irvine, Renfro Valley, McKee, London, Somerset, Nicholasville, Lexington, Danville, and Harrodsburg. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Berea?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help with passport photos in Berea?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and Walmart locations in Berea and Richmond offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Berea?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Berea?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Madison County families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Berea", address: "101 Bingham Dr, Berea, KY 40403", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Berea", address: "200 Brenwood St, Berea, KY 40403", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart — Berea", address: "120 Jill Dr, Berea, KY 40403", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Rite Aid — Berea", address: "124 N Broadway, Berea, KY 40403", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/" },
    { name: "CVS Pharmacy — Richmond", address: "859 Eastern Bypass, Richmond, KY 40475", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walmart — Richmond", address: "820 Eastern Bypass, Richmond, KY 40475", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Richmond", address: "2001 Lantern Ridge Dr, Richmond, KY 40475", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Lexington", address: "120 W Reynolds Rd, Lexington, KY 40503", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    {
      name: "Circuit Court Clerk — Madison County",
      address: "135 W Irvine St, Richmond, KY 40475",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Driver's license and REAL ID. Appointment recommended.",
      featured: true,
    },
    {
      name: "Circuit Court Clerk — Rockcastle County",
      address: "205 E Main St, Mount Vernon, KY 40456",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "REAL ID and driver's license renewals. Online booking available.",
      featured: false,
    },
    {
      name: "Circuit Court Clerk — Estill County",
      address: "140 Main St, Irvine, KY 40336",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service center for Estill County residents.",
      featured: true,
    },
    {
      name: "Circuit Court Clerk — Laurel County",
      address: "200 S Main St, London, KY 40741",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Alternative for Laurel County residents. Walk-ins limited.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "LEX",
      name: "Blue Grass Airport (Lexington)",
      distance: "40 miles from Berea",
      address: "4000 Terminal Dr, Lexington, KY 40510",
      note: "The primary airport for Madison County. Domestic flights with connections to major international hubs. Accessible via I-75.",
      flightUrl: "https://www.bluegrassairport.com/",
      flightLabel: "Blue Grass Airport",
      featured: true,
    },
    {
      code: "SDF",
      name: "Louisville Muhammad Ali International",
      distance: "110 miles from Berea",
      address: "600 Terminal Dr, Louisville, KY 40209",
      note: "Alternative regional airport with flights to major hubs.",
      flightUrl: "https://www.flylouisville.com/",
      flightLabel: "Louisville Airport",
      featured: false,
    },
    {
      code: "TYS",
      name: "McGhee Tyson Airport (Knoxville)",
      distance: "130 miles from Berea",
      address: "2055 Alcoa Hwy, Alcoa, TN 37701",
      note: "Alternative regional airport for southern destinations.",
      flightUrl: "https://www.tys.org/",
      flightLabel: "McGhee Tyson Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Birth & Death Certificates", desc: "Kentucky Office of Vital Statistics in Frankfort — order certified copies online, by mail, or in person for passport applications and name changes.", url: "https://www.chfs.ky.gov/agencies/dph/dehp/vsb/Pages/default.aspx" },
    { icon: "ri-heart-line", label: "Marriage Records", desc: "Madison County Clerk — certified marriage licenses for name change passport applications and legal documentation.", url: "https://www.madisoncountyky.us/" },
    { icon: "ri-scales-line", label: "Divorce Decrees", desc: "Madison Circuit Court Clerk — certified divorce decrees supporting passport name change or correction.", url: "https://kycourts.gov/Courts/Circuit-Court/Pages/Madison.aspx" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "If your record was issued outside Kentucky, order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};